import * as React from 'react';
import * as RadixAccordion from '@radix-ui/react-accordion';
import './accordion.css';
import { Text } from '@radix-ui/themes';

export const Accordion = ({
    children,
    ...props
}: React.ComponentPropsWithRef<typeof RadixAccordion.Root>) => (
    <RadixAccordion.Root className="AccordionRoot" {...props}>
        {children}
    </RadixAccordion.Root>
);

Accordion.Trigger = ({
    children,
    className,
    icon,
    ...props
}: React.ComponentPropsWithRef<typeof RadixAccordion.Trigger> & {
    icon?: React.ReactNode;
}) => {
    return (
        <RadixAccordion.Header className="AccordionHeader">
            <RadixAccordion.Trigger className="AccordionTrigger" {...props}>
                {children}
                {icon && (
                    <Text className="AccordionChevron" aria-hidden>
                        {icon}
                    </Text>
                )}
            </RadixAccordion.Trigger>
        </RadixAccordion.Header>
    );
};

Accordion.Item = ({ children, value }: { children: React.ReactNode; value: string }) => (
    <RadixAccordion.Item value={value} className="AccordionItem">
        {children}
    </RadixAccordion.Item>
);

Accordion.displayName = RadixAccordion.Item.displayName;

Accordion.Content = ({
    children,
    ref,
    ...props
}: React.ComponentPropsWithRef<typeof RadixAccordion.Content>) => (
    <RadixAccordion.Content className="AccordionContent" {...props}>
        <div className="AccordionContentText">{children}</div>
    </RadixAccordion.Content>
);
